import * as types from "./actionTypes";

const initialState = {
  loading: false,
  isSuccess: false,
  payload: {},
  error: null
};

export default function loginReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_LOADING:
      return {
        ...state,
        loading: true
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isSuccess: true,
        error: null,
        payload: action.payload
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}
